var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.hover.top",value:({
    title: _vm.$options.i18n.toggleText,
    boundary: 'viewport',
  }),expression:"{\n    title: $options.i18n.toggleText,\n    boundary: 'viewport',\n  }",modifiers:{"hover":true,"top":true}}],attrs:{"items":_vm.dropdownItems,"toggle-text":_vm.$options.i18n.toggleText,"icon":"ellipsis_v","category":"tertiary","placement":"right","data-testid":"branch-more-actions","text-sr-only":"","no-caret":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }